export const advertStatusEnum = {
  Scheduled: 1,
  Running: 2,
  Expired: 3,
  Inactive: 4,

  getKeyByValue(value) {
    return Object.keys(this).find(key => this[key] === value);
  },
};

export const advertStatusColorEnum = colors => ({
  [advertStatusEnum.Scheduled]: {
    color: colors.white,
    backgroundColor: colors.blueMain,
  },
  [advertStatusEnum.Running]: {
    color: colors.white,
    backgroundColor: colors.blueMain,
  },
  [advertStatusEnum.Expired]: {
    color: colors.white,
    backgroundColor: colors.blueMain,
  },
  [advertStatusEnum.Inactive]: {
    color: colors.white,
    backgroundColor: colors.grey005,
  },
});
